import * as React from "react";
import { Notification } from "../Notification";
import { AnonymousUser } from "@draftkings/arena-web";
export const UnauthorizedScreen = React.memo(function UnauthorizedScreen(props) {
    const { dictionary, onClick } = props;
    return (React.createElement(Notification, { title: dictionary.myBetsDictionary.UnauthorizedMessageTitle, subtitle: dictionary.myBetsDictionary.UnauthorizedMessageSubtitle, btnText: dictionary.myBetsDictionary.UnauthorizedBtnText, onClick: onClick },
        React.createElement(AnonymousUser, { variant: "anonymousUser" })));
});
//# sourceMappingURL=UnauthorizedScreen.js.map